import styled from 'styled-components';

export const IconButtonWrapper = styled.div`
    display: flex;
    height: 100%;
    justify-content: flex-end;
`;